var ms = function ms(seconds) {
  return seconds * 1000;
};

export { ms };